import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "product-swiper" };
const _hoisted_2 = { class: "product-swiper-nav" };
const _hoisted_3 = {
    type: "button",
    class: "btn btn-icon swiper-button-prev product-swiper-nav-btn product-swiper-nav-btn--prev"
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", { class: "visually-hidden" }, "Previous slide", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "product-swiper-pagination" }, null, -1);
const _hoisted_6 = {
    type: "button",
    class: "btn btn-icon swiper-button-next product-swiper-nav-btn product-swiper-nav-btn--next"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "visually-hidden" }, "Next slide", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_swiper = _resolveComponent("swiper");
    const _component_inline_svg = _resolveComponent("inline-svg");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_swiper, _mergeProps({
            onSwiper: _ctx.setThumbsSwiper,
            class: "product-swiper-thumbs"
        }, {
            direction: 'vertical',
            spaceBetween: 8,
            threshold: 5,
            watchOverflow: true,
            centeredSlides: false,
            slideToClickedSlide: true,
            controller: {
                control: _ctx.mainSwiper
            }
        }), {
            default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "thumbs-slides")
            ]),
            _: 3
        }, 16, ["onSwiper"]),
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_swiper, _mergeProps({ onSwiper: _ctx.setMainSwiper }, {
                spaceBetween: 0,
                threshold: 5,
                watchOverflow: true,
                controller: {
                    control: _ctx.thumbsSwiper
                },
                navigation: {
                    prevEl: '.product-swiper-nav-btn--prev',
                    nextEl: '.product-swiper-nav-btn--next',
                },
                pagination: {
                    el: '.product-swiper-pagination',
                    clickable: true,
                    type: 'fraction',
                },
            }), {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "main-slides")
                ]),
                _: 3
            }, 16, ["onSwiper"])
        ]),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", _hoisted_3, [
                _createVNode(_component_inline_svg, {
                    src: require('@dw_boilerplate/Partials/Icons/Arrow-long.svg')
                }, null, 8, ["src"]),
                _hoisted_4
            ]),
            _hoisted_5,
            _createElementVNode("button", _hoisted_6, [
                _createVNode(_component_inline_svg, {
                    src: require('@dw_boilerplate/Partials/Icons/Arrow-long.svg')
                }, null, 8, ["src"]),
                _hoisted_7
            ])
        ])
    ]));
}
